import { Button } from "@mui/material";

import { useDocumentListStore } from "../../../../components/modules/Documents/ViewDocuments/hooks/useDocumentListStore";
import UploadDocuments from "../../../modules/Documents/UploadDocuments";
import HNSColors from "../../../ui library/HNSColors";

export default function UploadButton() {
  const { setIsUploadModalOpen } = useDocumentListStore();

  return (
    <>
      <Button
        variant="contained"
        onClick={() => setIsUploadModalOpen(true)}
        size="small"
        style={{ width: "13rem" }}
        sx={{
          boxShadow: "none",
          borderRadius: "999px",
          textTransform: "none",
          padding: "10px 18px",
          backgroundColor: HNSColors.secondary[500],
          borderColor: "transparent",
          color: HNSColors.neutrals[900],
          "&:hover": {
            boxShadow: "none",
            backgroundColor: HNSColors.secondary[600],
            borderColor: "transparent",
            color: HNSColors.neutrals[900],
          },
        }}
      >
        Upload Document
      </Button>
      <UploadDocuments isModal={true} />
    </>
  );
}
